import type { QuizSteps } from "@/types/api.types";
import { useMemo, useState } from "react";
import StickyAnswerCta from "@/components/atoms/StickyAnswerCta";
import { useStickyLastOption } from "@/hooks/useStickyLastOption";
import { useQuizData } from "@/hooks/useQuizData";

const NO_LABELS: string[] = [];

const MultipleStepSelect = ({ step, onAnswer }: QuizSteps) => {
  const [selected, setSelected] = useState<string[]>([]);
  const buttonLabel = step.buttonText || "Continue";
  const { data } = useQuizData();
  const stickySettings = data?.settings?.stickyLastAnswer;
  // Options only toggle here, so the sticky CTA mirrors the submit button instead.
  const submitLabels = useMemo(() => [buttonLabel], [buttonLabel]);
  const { listRef, stickyOption: stickyLabel } = useStickyLastOption(
    stickySettings?.enabled ? submitLabels : NO_LABELS,
  );

  return (
    <div className="mx-auto max-w-md px-4 py-8">
      <h1 className="mb-6 text-center text-2xl font-bold text-gray-900">
        {step.title}
      </h1>
      <div className="flex flex-col gap-3">
        {step.options?.map((option) => (
          <button
            key={option.id}
            onClick={() => {
              if (selected.includes(option.value)) {
                setSelected(selected.filter((item) => item !== option.value));
              } else {
                setSelected([...selected, option.value]);
              }
            }}
            className={`w-full rounded-xl border p-4 text-left font-medium transition-all ${
              selected.includes(option.value)
                ? "border-blue-500 bg-blue-50 text-blue-700 shadow-sm ring-1 ring-blue-500"
                : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
      <br />
      <div ref={listRef}>
        <button
          disabled={selected.length === 0}
          onClick={() => onAnswer(selected)}
          className="mt-4 w-full rounded-xl bg-blue-600 px-6 py-3 font-semibold text-white transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500"
        >
          {buttonLabel}
        </button>
      </div>

      {stickyLabel && (
        <StickyAnswerCta
          label={stickyLabel}
          disabled={selected.length === 0}
          onClick={() => onAnswer(selected)}
          settings={stickySettings}
        />
      )}
    </div>
  );
};

export default MultipleStepSelect;
